import { render } from "./MenuItems.vue?vue&type=template&id=c05698ee"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"

import "./MenuItems.vue?vue&type=style&index=0&id=c05698ee&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__